import React from 'react'
import aboutImg from '../assets/img/Handcodingrafiki.png'

const About = () => {
  return (
    <>
     <section className="about section" id="about">
                <h2 className="section__title">About Me</h2>
                <span className="section__subtitle">My Introduction</span>

                <div  className="about__container container grid">
                    <img src={aboutImg} alt='about' className="about__img"/>
                    <div className="about__data">
                        <p className="about__description">
                            Web developer with exclusive knowledge and experience, working in web technologies an ux/ui 
                        </p>

                        <div className="about__info">
                            <div>
                                <span className="about__info-title">1+</span>
                                <span className="about__info-name">Year<br/> experience</span>
                            </div>
                            <div>
                                <span className="about__info-title">5+</span>
                                <span className="about__info-name">Completed <br/> Projects</span>
                            </div>
                            <div>
                                <span className="about__info-title">1</span>
                                <span className="about__info-name">Company<br/> working</span>
                            </div>
                        </div>

                        {/* <div className="about__buttons">
                             <a download="" href="assets/pdf/Alexa-Cv.pdf" className="button button--flex">Download CV
                                <i className='uil uil-download-alt button__icon'></i> 
                             </a>
                        </div> */}
                    </div>
                </div>
            </section>

    </>
  )
}

export default About